import { isString } from '@guardian/libs';
// TODO: this function already exists in commercial-core, consider exporting it to avoid duplication
const getUrlKeywords = (url) => {
    const lastSegment = url
        .split('/')
        .filter(Boolean) // This handles a trailing slash
        .slice(-1)[0];
    return isString(lastSegment) ? lastSegment.split('-').filter(Boolean) : [];
};
export const buildAdTargeting = ({ isAdFreeUser, isSensitive, edition, section, sharedAdTargeting, adUnit, videoDuration, }) => {
    if (isAdFreeUser) {
        return {
            disableAds: true,
        };
    }
    const customParams = {
        sens: isSensitive ? 't' : 'f',
        si: 'f',
        vl: videoDuration || 0,
        cc: edition,
        s: section,
        inskin: 'f',
        ...sharedAdTargeting,
        pa: 'f',
        urlkw: getUrlKeywords(String(sharedAdTargeting.url)),
    };
    return {
        customParams,
        adUnit,
    };
};
